const tooltips = {
  esetek: 'A felületen különböző típusú eseteket lehet rögzíteni, adott helyszínnel kapcsolatban.',
  allapot: 'Ezen a felületen rögzíthetőek azok az állapotok, amiket az eset típusok fel tudnak venni.',
  esettipus: 'Eset típusok rögzítésére és karbantartására szolgáló felület.',
  elerhetoseg: 'A helyszínek ügyfélszolgálatának az elérhetőségét lehet itt berögzíteni és karbantartani. Az Idő mezőben rögzíthető az az idősáv, amelyben az ügyfélszolgálat elérhető.',
  ertesitendo: 'Az értesítés a személyi törzsben szereplő helyszín figyelembe vételével kerül küldésre.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
